import axios from "../axiosInstance";

class CnaeTypeService {
  async getCnaeTypeList() {
    return await axios.get("cnaetype");
  }
}

export default new CnaeTypeService();
